import { render, staticRenderFns } from "./serviceRequestsHome.vue?vue&type=template&id=185992f9&"
import script from "./serviceRequestsHome.vue?vue&type=script&lang=js&"
export * from "./serviceRequestsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports